import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <>
      <footer className="bg-dark">
        <p>&copy; 2023 - Jon Waaler</p>
      </footer>
    </>
  );
}

export default Footer;
